import { useAppSelector } from '@/hooks/redux';
import { selectUserRole } from '@/store/auth/authSlice';

export const useIdRole = () => useAppSelector(selectUserRole);
